var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7246 8.64648C15.0908 8.28027 15.0908 7.68555 14.7246 7.31934L10.9746 3.56934C10.6084 3.20312 10.0137 3.20312 9.64746 3.56934C9.28125 3.93555 9.28125 4.53027 9.64746 4.89648L11.7979 7.04688H5.625C5.10645 7.04688 4.6875 7.46582 4.6875 7.98438C4.6875 8.50293 5.10645 8.92188 5.625 8.92188H11.7979L9.64746 11.0723C9.28125 11.4385 9.28125 12.0332 9.64746 12.3994C10.0137 12.7656 10.6084 12.7656 10.9746 12.3994L14.7246 8.64941V8.64648ZM4.6875 3.29688C5.20605 3.29688 5.625 2.87793 5.625 2.35938C5.625 1.84082 5.20605 1.42188 4.6875 1.42188H2.8125C1.25977 1.42188 0 2.68164 0 4.23438V11.7344C0 13.2871 1.25977 14.5469 2.8125 14.5469H4.6875C5.20605 14.5469 5.625 14.1279 5.625 13.6094C5.625 13.0908 5.20605 12.6719 4.6875 12.6719H2.8125C2.29395 12.6719 1.875 12.2529 1.875 11.7344V4.23438C1.875 3.71582 2.29395 3.29688 2.8125 3.29688H4.6875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.bc6cd5efd23e2b2314ab2a38441bafd6.svg";
export { ForwardRef as ReactComponent };